import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Button } from "@/components/ui/button";
import { Info, ArrowRight } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

const TOUR_STEPS = [
  {
    title: "Velkommen til saker",
    description: "Her kan du administrere alle dine saker på ett sted.",
    target: ".case-header"
  },
  {
    title: "Søk og filtrer",
    description: "Bruk søkefeltet for å finne saker raskt.",
    target: ".search-section"
  },
  {
    title: "Saksliste",
    description: "Her vises alle dine aktive saker.",
    target: ".cases-table"
  }
];

export function OnboardingTour() {
  const [currentStep, setCurrentStep] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    const hasSeenTour = localStorage.getItem('hasSeenCasesTour');
    if (!hasSeenTour) {
      setIsVisible(true);
    }
  }, []);

  const handleNext = () => {
    if (currentStep < TOUR_STEPS.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      setIsVisible(false);
      localStorage.setItem('hasSeenCasesTour', 'true');
      toast({
        title: "Omvisning fullført!",
        description: "Du er nå klar til å begynne å jobbe med saker.",
        className: "bg-green-50 border-green-200",
      });
    }
  };

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-4 right-4 bg-white rounded-lg shadow-lg p-4 max-w-sm border border-amber-200 z-50"
    >
      <div className="flex items-start gap-3">
        <div className="p-2 bg-amber-100 rounded-full">
          <Info className="h-4 w-4 text-amber-700" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold mb-1">{TOUR_STEPS[currentStep].title}</h3>
          <p className="text-sm text-muted-foreground mb-4">
            {TOUR_STEPS[currentStep].description}
          </p>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">
              {currentStep + 1} av {TOUR_STEPS.length}
            </span>
            <Button
              size="sm"
              onClick={handleNext}
              className="bg-amber-500 hover:bg-amber-600 text-white"
            >
              {currentStep === TOUR_STEPS.length - 1 ? (
                "Fullfør"
              ) : (
                <>
                  Neste <ArrowRight className="ml-2 h-4 w-4" />
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}